import { api } from "./axiosClient";
import type { SettingDefinition } from "../types/settingDefination.types";

export const settingDefinitionApi = {
  searchSettingDefinitions: async (payload: any) => {
    const response = await api.post("/settingdefinition/Search", payload);
    return response.data;
  },

  createSettingDefinition: async (data: Partial<SettingDefinition>) => {
    const response = await api.post("/settingdefinition/create", data);
    return response.data;
  },

  updateSettingDefinition: async (data: Partial<SettingDefinition>) => {
    const response = await api.post("/settingdefinition/edit", data);
    return response.data;
  },

  activateSettingDefinition: async (id: string) => {
    return await api.post("/settingdefinition/activate", { id });
  },

  deActivateSettingDefinition: async (id: string) => {
    return await api.post("/settingdefinition/deactivate", { id });
  },

  removeSettingDefinition: async (id: string) => {
    return await api.post("/settingdefinition/remove", { id });
  },
};
